export const dealerLocatorDrawerTranslationKeys: string[] = [
  '1628_ACCEPT_TERMS_AND_CONDITIONS_2',
  'APPLY_CHANGES',
  'ARIA_LANDMARK_FILTER',
  'CANCEL',
  'CAT_EMAIL_DEALERNAME',
  'CAT_SELECT_STORE',
  'CAT_SHOPPING_PREFERENCES_SELECT_STORE',
  'CHECK_PRICE_ENTER_LOCATION',
  'CLEAR_ALL_FILTERS',
  'CU_WEBSITE',
  'DEALERS_TERMS_OF_USE',
  'DRIVING_DIRECTIONS',
  'ENTER_LOCATION',
  'FILTER_AND_SORT',
  'FOOTER_CONTACT_US',
  'FOOTER_CUSTOMER_SERVICE',
  'FYD_ADJUST_SEARCH',
  'FYD_BLOCKED_COUNTRY_LOCATION',
  'FYD_FILTER_SERVICES_OFFERED',
  'FYD_INVALID_LOCATION',
  'FYD_MAP_VIEW',
  'FYD_NO_RESULTS',
  'FYD_RESULTS_CLOSEST',
  'FYD_SEARCH_THIS_AREA',
  'FYD_SORT_CLOSEST',
  'GENERAL_BACK_TO',
  'OPEN_24_HOUR',
  'OPEN_24_HOURS_7_DAYS_A_WEEK',
  'REGISTER_MODAL_1_SELECT_LOCAL_STORE',
  'REGISTER_MODAL_2_CREATE_LOCAL_PROFILE',
  'REGISTER_MODAL_3_VERIFY_EMAIL_ADDRESS',
  'REGISTER_MODAL_4_CREATE_CAT_ACCOUNT',
  'REGISTER_MODAL_SELECT_DEALER_STORE',
  'REGISTER_MODAL_SIGN_IN_PROMPT',
  'REGISTER_MODAL_STEPS_SUBTITLE',
  'REQUIRED',
  'SERVICES_ENGINE_SERVICE',
  'SERVICES_EQUIPT_SALES',
  'SERVICES_EQUIPT_SERVICE',
  'SERVICES_MACHINE',
  'SERVICES_MARINE',
  'SERVICES_OFFERED',
  'SERVICES_PARTS_PICKUP',
  'SERVICES_PARTS_SALES',
  'SERVICES_POWER_SYSTEMS',
  'SERVICES_RENTALS',
  'SERVICES_TECHNOLOGY_SOLUTIONS',
  'SHOP_AS_GUEST',
  'SIGN_IN',
  'SORT',
  'STEP_1',
  'STORE_HOURS',
  'UNKNOWN_ERROR_MESSAGE',
  'UNKNOWN_ERROR_TITLE',
  'UR_CAT_ACCEPT_TERMS',
  'UR_CAT_DEALER_PRIVACY_NOTICE_HREF',
  'UR_CAT_PRIVACY_NOTICE_HREF',
  'UR_PARTS_TERMS_OF_USE_HREF',
  'VIEW_MORE_PRODUCTS',
  'SEARCH_FOR_PART_NUMBER_OR_NAME',
  'WELCOME_TO_PARTS_COM',
  'WELCOME_PCC_LOGGED_IN_NO_DEALER'
];
